export default {
  brand: "USFansSheet",
  nav: {
    home: "Inicio",
    categories: "Categorías",
    guides: "Guías",
    guide: "Guía de compras",
    faq: "FAQ",
    safety: "Seguridad",
    mainWebsite: "Sitio principal",
  },
  hero: {
    badge: "Recurso de compra independiente",
    title: "La forma más inteligente de explorar la hoja USFans Spreadsheet",
    subtitle: "Explora categorías de productos organizadas, información de vendedores, guías de control de calidad, detalles de envío y consejos de seguridad, todo en un solo lugar limpio.",
    ctaPrimary: "USFans Spreadsheet",
    ctaSecondary: "Comprar ahora",
    ctaGuide: "Leer la guía de USFans",
    trust: "Recurso independiente · Actualizado regularmente · Multilingüe",
  },
  categories: {
    title: "Compra por categoría",
    subtitle: "Explora cada categoría de productos de la hoja USFans Spreadsheet. Elige una categoría para abrirla en el sitio principal.",
    dropdownLabel: "Todas las categorías",
    dropdownHint: "Selecciona una categoría",
    popularTitle: "Categorías populares",
    viewAll: "Ver todas las categorías",
  },
  intro: {
    eyebrow: "Qué es",
    title: "¿Qué es la hoja USFans Spreadsheet?",
    p1: "La hoja USFans Spreadsheet es una referencia organizada que reúne listados de productos, categorías y detalles de compra en un formato de tabla sencillo. En lugar de saltar entre muchas páginas, abres un solo lugar para revisar artículos, comprobar categorías y encontrar los enlaces que necesitas.",
    p2: "Nuestro objetivo en USFansSheet es facilitar esa investigación, con accesos directos claros a categorías, orientación honesta y consejos útiles sobre control de calidad, envío y seguridad, antes de continuar al recurso principal.",
    cta: "Explorar la hoja USFans Spreadsheet",
  },
  articles: {
    eyebrow: "Guías",
    title: "Guías de USFans Spreadsheet",
    subtitle: "Lee guías originales y fáciles de entender para investigar productos, vendedores, control de calidad, envío y seguridad.",
    readMore: "Leer guía",
    featured: "Guía destacada",
    comingSoon: "Próximamente",
    viewAll: "Ver todas las guías",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Preguntas frecuentes",
    subtitle: "Respuestas rápidas a las preguntas más comunes sobre la hoja USFans Spreadsheet.",
    q1: "¿Qué es la hoja USFans Spreadsheet?",
    a1: "Es un documento de referencia organizado que lista productos, categorías y detalles de compra en una tabla, usado como punto de partida para investigar.",
    q2: "¿Cómo uso la hoja USFans Spreadsheet?",
    a2: "Abre la categoría que necesitas, revisa las filas de productos, consulta las notas de control de calidad o envío y sigue los enlaces al sitio principal.",
    q3: "¿Es legítimo USFans?",
    a3: "Ofrecemos información independiente para ayudarte a investigar. Verifica siempre los datos actuales en fuentes oficiales antes de comprar.",
    q4: "¿La hoja cubre los costos de envío?",
    a4: "Muchos listados incluyen notas de envío, pero los costos finales dependen del peso, el método y el destino.",
    q5: "¿Necesito una cuenta para navegar?",
    a5: "Navegar por los recursos suele ser abierto, pero confirma siempre los requisitos de cuenta en el sitio oficial.",
  },
  cta: {
    title: "¿Listo para explorar más?",
    subtitle: "Usa nuestras guías para investigar USFans, comparar información y entender los factores más importantes antes de continuar al recurso principal.",
    primary: "Visitar el sitio principal",
    secondary: "Explorar todas las guías",
  },
  footer: {
    description: "USFansSheet es un recurso informativo independiente centrado en la hoja USFans Spreadsheet, que te ayuda a investigar productos, categorías, control de calidad, envío y seguridad.",
    explore: "Explorar",
    resources: "Recursos",
    categories: "Categorías",
    guides: "Guías",
    faq: "FAQ",
    mainWebsite: "Sitio principal",
    disclaimer: "USFansSheet.guru es un recurso informativo independiente y no está afiliado ni oficialmente respaldado por USFans, salvo que se indique explícitamente. Verifica siempre la información actual en fuentes oficiales antes de realizar compras o decisiones financieras.",
    rights: "Todos los derechos reservados.",
  },
  cat: {
    shoes: "Zapatos",
    hoodies: "Sudaderas / Suéteres",
    tshirts: "Camisetas",
    jackets: "Chaquetas",
    pants: "Pantalones / Pantalones cortos",
    headwear: "Gorros",
    sets: "Conjuntos",
    underwear: "Ropa interior / Calzoncillos",
    jersey: "Camiseta deportiva",
    accessories: "Accesorios",
    bags: "Bolsos",
    belts: "Cinturones",
    perfumes: "Perfumes",
    other: "Otros artículos",
  },
  article: {
    breadcrumbHome: "Inicio",
    breadcrumbGuides: "Guías",
    notFoundTitle: "Guía no encontrada",
    notFoundDesc: "La guía que buscas no está disponible. Vuelve a la página de inicio para explorar todos nuestros recursos.",
    backHome: "Volver al inicio",
    updated: "Actualizado",
    relatedTitle: "Guías relacionadas",
    ctaTitle: "Continúa tu investigación",
    ctaDesc: "Ahora que has leído esta guía, puedes explorar las categorías de productos o ir directamente al sitio principal para conocer el recurso completo.",
    ctaMain: "Visitar el sitio principal",
  },
};